import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import style from '../../DropdownMenu/DropdownMenu.module.scss.js';

/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Dropdowns/sub-components/internal/CountryTriggerImage.tsx)
 *
 * @param {string} countryCode - Two character country code.
 * @param {object} image - Image object.
 */
const CountryTriggerImage = ({ countryCode, image, }) => {
    return (jsx("img", { className: classNames(style['z-dropdown-menu__trigger-img'], style['z-dropdown-menu__trigger-img--rounded']), src: countryCode && !image
            ? `https://cdn.public.zooplus.net/media/ui-components/v6-latest/png/country-flags/1x1/${countryCode.toLowerCase()}.png`
            : image?.url, alt: image?.alt || '', width: image?.width || '24', height: image?.height || '24', loading: "lazy" }));
};

export { CountryTriggerImage };
//# sourceMappingURL=CountryTriggerImage.js.map
